import React from 'react';
import {Link, generatePath} from 'react-router-dom';
import routes from 'globals/routes';
import ProjectWrapper from 'components/projectWrapper';
import { useDataValue } from 'globals/contexts/dataContext';

import './imageSection.css';

const ImageSection = ({items}) => {

  return <section className="images" id="images">
    <ProjectWrapper items={items} filter={null}
      // items={currentProject} 
        selectedFilter={null} 
        // onProjectClick={setActiveProject}
        ProjectInfoRenderer = {({project}) => {
          return <div className="projectInfo">
            {/* <div className="name">
              {project['name']}
            </div> */}
            {/* <div className="line" /> */}
            <div>{project['caption']}</div>
            {/* <div className="count">{project['images'].length + (currentLanguage==="tc"? " 張相片": " photos")}</div> */}
          </div>;
        }}
      />
  </section>;
}
export default ImageSection;